const PROTOCOL_RE = /^(https?:)?\/\//;
const QUERY_RE = /\?.*/;
const PARAM_ORDER = [
    'w',
    'h',
    'fit',
    'f',
    'fm',
    'fl',
    'q',
    'r',
    'bg'
];
function buildContentfulImageUrl(rawUrl, params = {}) {
    const cleanPath = rawUrl.replace(PROTOCOL_RE, '').replace(QUERY_RE, '');
    const pairs = [];
    for (const key of PARAM_ORDER){
        const value = params[key];
        if (null != value) pairs.push(`${key}=${value}`);
    }
    const qs = pairs.length > 0 ? `?${pairs.join('&')}` : '';
    return `https://${cleanPath}${qs}`;
}
export { buildContentfulImageUrl };
